
import { Component, Vue } from 'vue-property-decorator'
import Chatbox from '@/components/V3/Wrapper.vue'
import CTA from '@/components/V3/CTA.vue'
import MainButton from '@/components/V3/MainButton.vue'

@Component({
  components: {
    Chatbox,
    CTA,
    MainButton
  }
})
export default class App extends Vue {
  get channels (): Array<any> {
    return this.$store.getters.channels
  }

  get isLeftPos (): boolean {
    return this.widgetPosition === 'left'
  }

  get isHidden (): boolean {
    return this.$store.getters.isHidden === true ||
    this.$store.getters.isOpen === false ||
    this.channels.length === 0
  }

  get style (): string {
    const leftOrRight = this.isLeftPos ? 'left' : 'right'
    return `${leftOrRight}: ${this.widgetOffset.x}px;
                  bottom: ${this.widgetOffset.y}px`
  }

  get widgetOffset (): { x: number, y: number } {
    return this.$store.getters.widgetOffset
  }

  get widgetPosition (): string {
    return this.$store.getters.widgetPosition
  }
}
